module.exports = __webpack_public_path__ + "static/media/glasses-alt.7e7c7d65.svg";